module.exports = __webpack_public_path__ + "static/media/perfil-1@3x.b94eeca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/perfil-1@3x.png
// module id = 1895
// module chunks = 0